// export const mainHost = "http://localhost:3001/";
export const mainHost = "https://lacuvenapi.dev.lacunaventure.com/";
// export const mainHost = "https://lacuna.venture.server.lacunaventure.com/";

//Admin Login Api
// export const loginLink = "auth/login"; //login api link

//signIn Api
export const createUser = "auth/signup"; //signIn api link

//login Api
export const loginUser = "auth/login"; //login api link

//otpVerify Api
export const otpVerification = "otpVerify/createOtp"; //otpVerify api link

// Otp resend api
export const otpResend = "otpVerify/resend"; //otpresend api link

// //store Serviceworker subscription endpoint
// export const storeSubscription = "subscribtion/storeSubscribtion";

// //delete serviceworker subscription endpoint
// export const deleteSubscription = "subscribtion/deleteSubscription";

// //admininfo
// export const currentAdmin = "admin/current-admin"; //get current admin data
